(function () {
  'use strict';

  var I18N = window.collectionI18n || {
    all_loaded: 'Tüm ürünler yüklendi',
    load_error: 'Yükleme başarısız.',
    retry: 'Tekrar dene'
  };

  function reorderUnavailableLast(grid) {
    if (!grid) return;
    var unavailable = grid.querySelectorAll('.collection-grid__item[data-product-available="false"]');
    if (!unavailable.length) return;
    var frag = document.createDocumentFragment();
    unavailable.forEach(function (el) { frag.appendChild(el); });
    grid.appendChild(frag);
  }

  /* URL'de ?sort_by=reviews-desc + filter aktifken bu modül devrede.
     (Filter yokken main-collection.liquid ayrı reviews-sorted-grid container
     render ediyor, bu modül o container'a hiç dokunmuyor.) Filter'lı
     senaryoda eski client-side reorder fallback olarak çalışır — atlama
     görülebilir ama Faz 1 sınırlaması olarak kabul edildi. */
  function sortByReviewsIfRequested(grid) {
    if (!grid) return;
    var sortBy = new URLSearchParams(window.location.search).get('sort_by');
    if (sortBy !== 'reviews-desc') return;

    var items = Array.prototype.slice.call(
      grid.querySelectorAll('.collection-grid__item')
    );
    if (items.length < 2) return;

    items.sort(function (a, b) {
      var ca = parseInt(a.getAttribute('data-review-count'), 10) || 0;
      var cb = parseInt(b.getAttribute('data-review-count'), 10) || 0;
      return cb - ca;
    });

    var frag = document.createDocumentFragment();
    items.forEach(function (el) { frag.appendChild(el); });
    grid.appendChild(frag);
  }

  function CollectionInfiniteScroll(container) {
    this.container = container;
    this.grid = container.querySelector('[data-infinite-grid]');
    this.sentinel = container.querySelector('[data-infinite-sentinel]');
    this.loader = container.querySelector('[data-infinite-loader]');
    this.statusEl = container.querySelector('[data-infinite-status]');
    this.pagination = container.querySelector('.collection-pagination');

    this.currentPage = parseInt(container.dataset.currentPage, 10) || 1;
    this.totalPages = parseInt(container.dataset.totalPages, 10) || 1;
    this.sectionId = container.dataset.sectionId;
    this.collectionUrl = container.dataset.collectionUrl;
    this.loading = false;
    this.done = this.currentPage >= this.totalPages;
    /* Arama sayfası bunu kapatır: stok durumuna göre yeniden sıralamak
       sonuçların alaka sırasını bozar. */
    this.reorderUnavailable = container.dataset.reorderUnavailable !== 'false';

    /* Diğer sortlar için client-side review reorder (sort_by=reviews-desc
       URL'de varsa). reviews-desc dropdown'undan geldiğinde bu modül
       devrede DEĞİL — main-collection.liquid ayrı container/JS render eder. */
    sortByReviewsIfRequested(this.grid);
    if (this.reorderUnavailable) reorderUnavailableLast(this.grid);

    if (this.pagination) this.pagination.hidden = true;

    if (this.done) {
      this.showDone();
      return;
    }

    if (!('IntersectionObserver' in window) || !this.sentinel) {
      if (this.pagination) this.pagination.hidden = false;
      return;
    }

    var self = this;
    this.observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting && !self.loading && !self.done) {
          self.loadNext();
        }
      },
      { rootMargin: '400px 0px' }
    );
    this.observer.observe(this.sentinel);

    /* URL senkronizasyonu (Google infinite-scroll rehberi): kullanıcı bir sayfanın
       içeriğine ulaştığında adres çubuğunu ?page=N ile güncelle. Böylece derin
       içerik paylaşılabilir/işaretlenebilir kalır. replaceState kullanılır → geri
       tuşu her scroll'da kirlenmez. Sunucu <a> sayfalaması JS-siz fallback olarak
       DOM'da kalmaya devam eder (crawlable). */
    this.urlObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            self.updateUrl(entry.target.getAttribute('data-page-start'));
          }
        });
      },
      { rootMargin: '0px 0px -80% 0px' }
    );
    var firstItem = this.grid && this.grid.querySelector('.collection-grid__item');
    if (firstItem) {
      firstItem.setAttribute('data-page-start', this.currentPage);
      this.urlObserver.observe(firstItem);
    }
  }

  CollectionInfiniteScroll.prototype.updateUrl = function (page) {
    var p = parseInt(page, 10);
    if (!p) return;
    try {
      var url = new URL(window.location.href);
      if (p <= 1) {
        url.searchParams.delete('page');
      } else {
        url.searchParams.set('page', p);
      }
      window.history.replaceState({ infinitePage: p }, '', url.toString());
    } catch (e) {}
  };

  CollectionInfiniteScroll.prototype.buildUrl = function (page) {
    var url = new URL(this.collectionUrl, window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach(function (v, k) {
      if (k !== 'page') url.searchParams.set(k, v);
    });
    url.searchParams.set('page', page);
    url.searchParams.set('section_id', this.sectionId);
    return url.toString();
  };

  CollectionInfiniteScroll.prototype.loadNext = function () {
    var self = this;
    this.loading = true;
    this.hideStatus();
    this.showLoader();

    var nextPage = this.currentPage + 1;

    fetch(this.buildUrl(nextPage), { headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var appended = self.appendPage(html, nextPage);
        self.currentPage = nextPage;
        self.hideLoader();
        if (!appended || self.currentPage >= self.totalPages) {
          self.done = true;
          self.showDone();
          if (self.observer) self.observer.disconnect();
        }
      })
      .catch(function () {
        self.hideLoader();
        self.showError();
      })
      .then(function () {
        self.loading = false;
      });
  };

  CollectionInfiniteScroll.prototype.appendPage = function (html, page) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newGrid = doc.querySelector('[data-infinite-grid]');
    if (!newGrid) return false;
    var items = newGrid.querySelectorAll('.collection-grid__item');
    if (!items.length) return false;
    var frag = document.createDocumentFragment();
    items.forEach(function (item, i) {
      if (i === 0) item.setAttribute('data-page-start', page);
      frag.appendChild(item);
    });
    var firstNew = frag.firstChild;
    this.grid.appendChild(frag);
    /* Yeni sayfanın başlangıç kartını URL gözlemcisine ekle (?page=N güncellemesi) */
    if (this.urlObserver && firstNew && firstNew.nodeType === 1) {
      this.urlObserver.observe(firstNew);
    }
    sortByReviewsIfRequested(this.grid);
    if (this.reorderUnavailable) reorderUnavailableLast(this.grid);
    return true;
  };

  CollectionInfiniteScroll.prototype.showLoader = function () {
    if (this.loader) this.loader.hidden = false;
  };

  CollectionInfiniteScroll.prototype.hideLoader = function () {
    if (this.loader) this.loader.hidden = true;
  };

  CollectionInfiniteScroll.prototype.hideStatus = function () {
    if (this.statusEl) {
      this.statusEl.hidden = true;
      this.statusEl.textContent = '';
    }
  };

  CollectionInfiniteScroll.prototype.showDone = function () {
    this.hideLoader();
    if (this.statusEl) {
      this.statusEl.textContent = I18N.all_loaded;
      this.statusEl.hidden = false;
    }
  };

  CollectionInfiniteScroll.prototype.showError = function () {
    if (!this.statusEl) return;
    var self = this;
    this.statusEl.textContent = '';

    var msg = document.createElement('span');
    msg.className = 'collection-infinite__error-text';
    msg.textContent = I18N.load_error + ' ';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'collection-infinite__retry';
    btn.textContent = I18N.retry;
    btn.addEventListener('click', function () {
      self.hideStatus();
      self.loadNext();
    });

    this.statusEl.appendChild(msg);
    this.statusEl.appendChild(btn);
    this.statusEl.hidden = false;
  };

  function init() {
    document.querySelectorAll('[data-infinite-scroll]').forEach(function (el) {
      if (el.dataset.infiniteInit) return;
      el.dataset.infiniteInit = '1';
      new CollectionInfiniteScroll(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
